// extracted by mini-css-extract-plugin
module.exports = {"ownerBlock":"style_ownerBlock__3pIPP","fullname":"style_fullname__1teTW","arrow":"style_arrow__3YhLs","toLogin":"style_toLogin__9IFRi"};